module.exports = __webpack_public_path__ + "img/bg_share_2.aa1e6c99.png";